import { useState } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { reminderDetail } from "../../../pages/api/reminder_detail";

import { ReferralIcon, FinancingIcon, ReKYCIcon, InsuranceIcon } from "../../icons";
import DetailsSidebarCard from "./detailsOpportunitySidebar";
import InteractionsSidebarCard from "./interactionsOpportunitySidebar";

const SidebarTabsContents =({ showSidebar, setShowSidebar, leadID, accName, statusName, product, oppName, hunterID }) => {
    const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
    const [activeTab, setActiveTab] = useState('details');
    const [sendLead, setSendLead] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const {contactData, accountOwnsership, reminderData, interactions, interactionsCount, totalPages} = reminderDetail({leadID, page, pageSize});
    
    const leadSourceLabels = {
        0: "Raw Lead",
        1: "Fresh Lead",
        2: "Profile Completed",
        3: "Meeting Completion",
        4: "Onboarded",
        5: "Activated",
        11: "Tanked",
    };
    const getOpportunityStatus = (status) => {
        const styles = {
            'Raw Lead': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Fresh Lead': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Profile Completed': "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
            'Activated': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Informaton Gathered': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Onboarded': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Collecting Documents': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Compliance Reviewing': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'KYC Approved': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'To Be Re-KYC': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'KYC Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Preparing Quotations': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Pending Selected': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Pending Payment': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Expired': "bg-[#EEEEEE] border-[#EEEEEE] text-[#94A3B8]"
        };
        return styles[status] || "bg-gray-100 text-gray-600";
    };

    return(
        <>
            <div className={`overflow-auto scrollbar-hide flex fixed top-0 right-0 h-full w-[448px] bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
                ${showSidebar ? 'translate-x-0' : 'translate-x-full'}`
            }>
                <div className="px-4 py-3 flex-col border-b justify-between w-full">
                    <div className="flex flex-row justify-between items-center">
                        <button
                            onClick={() => setShowSidebar(false)}
                            className="w-[34px] h-[34px] gap-2 px-1 hover:text-gray-700 border rounded-full border-[#1E293B] text-[#1E293B]"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                            </svg>
                        </button>
                        {/* <a 
                        // href={`/account_details?lead_id=${leadID}`}
                        className="w-auto h-auto p-3 gap-2 rounded-full border border-solid p-2 hover:bg-[#E2E8F0] border-[#1E293B] text-[#1E293B] text-sm font-bold whitespace-nowrap">
                            View Full Details
                        </a> */}
                    </div>
                    <div className="py-4 px-2 flex flex-col justify-between ">
                        <h3 className="text-sm font-bold text-[#94A3B8]">ID-{leadID}</h3>
                        <h1 className='text-xl font-bold py-2'>{accName}</h1>
                        <h3 className="text-sm font-bold text-[#94A3B8] pb-4">{oppName}</h3>
                        <div className="flex flex-row gap-2 whitespace-nowrap">
                            <span className="w-auto h-[40px] py-2 px-4 gap-2 top-5 left-[22px]">
                                {product === 'Financing' && <img src={FinancingIcon} alt="Financing" className="w-6 h-6 inline-block gap-1"/>}
                                {product === 'Re-KYC' && <img src={ReKYCIcon} alt="Re-KYC" className="w-6 h-6 inline-block gap-1" />}
                                {product === 'Insurance' && <img src={InsuranceIcon} alt="Insurance" className="w-6 h-6 inline-block gap-1" />}
                                {product === 'Referral' && <img src={ReferralIcon} alt="Referral" className="w-6 h-6 inline-block gap-1" />}
                            </span>
                            <span className={`w-auto h-[40px] py-2 px-4 gap-2 top-5 left-[22px] rounded-full border font-bold ${getOpportunityStatus(statusName)}`}>
                                {statusName || "Unknown"}
                            </span>
                        </div>
                        <div className="pt-4 flex justify-between border-b items-center border-gray-200 overflow-y-hidden scrollbar-hide cursor-pointer">
                            <a 
                                onClick={() => setActiveTab('details')}
                                className={`flex-1 text-center font-bold pb-2 -mb-[1px] ${activeTab === 'details' ? 'border-b-4 border-[#F7E21E] text-[#1E293B]' : 'text-[#94A3B8]'}`}
                            >
                                Details
                            </a>
                            <a 
                                onClick={() => setActiveTab('interaction')}
                                className={`flex-1 text-center font-bold pb-2 -mb-[1px] ${activeTab === 'interaction' ? 'border-b-4 border-[#F7E21E] text-[#1E293B]' : 'text-[#94A3B8]'}`}
                            >
                                Interaction History
                            </a>
                        </div>
                        <div className="py-4">
                            {activeTab === 'details' && (
                                <div>
                                    <DetailsSidebarCard 
                                    contactData={contactData} 
                                    reminderData={reminderData}
                                    accountOwnership={accountOwnsership}
                                    />
                                </div>
                            )}
                            {activeTab === 'interaction' && (
                                <div className='overflow-auto'>
                                    <InteractionsSidebarCard 
                                    interactions = {interactions}
                                    page = {page}
                                    pageSize = {pageSize}
                                    interactionsCount = {interactionsCount}
                                    totalPages = {totalPages}
                                    setPage = {setPage}/>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div 
                onClick={() => setShowSidebar(false)}
                className={`fixed inset-0 bg-black transition-opacity duration-300 ease-in-out z-40 ${
                showSidebar ? 'opacity-30 visible' : 'opacity-0 invisible'
                }`}
            />
            
        </>
    )
};
export default SidebarTabsContents;